import { combineReducers } from "redux";
import SessionErrorsReducer from "./sessionErrorsReducer";

const ErrorsReducer = combineReducers({
    sessionErrors: SessionErrorsReducer
});

export default ErrorsReducer;